import moment from 'moment'

export const findMultidayPrice = (info, startDate, endDate, multi_day_pricing_list) => {
  //this is copied from the searchCard.js file. refactoring can go blah blah blah.

  const {
    day_price_cents,
    day_price_5_cents,
    day_price_10_cents,
    day_price_15_cents,
    has_multiday,
    day_price_N_cents,
  } = info

  let startDateMoment = moment(startDate, 'YYYY-MM-DD')
  let endDateMoment = moment(endDate, 'YYYY-MM-DD')
  let dayDiff = endDateMoment.diff(startDateMoment, 'days')
  let dailyPrice = 0

  if (!has_multiday) {
    return day_price_cents
  }

  if (multi_day_pricing_list == null) {
    return day_price_cents
  }

  if (isNaN(dayDiff)) {
    //if there are no days, return the lowest price.
    dailyPrice = day_price_N_cents?.more_than_4_days ?
      day_price_N_cents?.more_than_4_days : day_price_cents
  }

  if ((dayDiff === 0 && multi_day_pricing_list?.includes(1))) {
    //if 1 day only or same day pickup dropoff
    dailyPrice = day_price_N_cents?.one_day ?
      day_price_N_cents?.one_day : day_price_cents
  } else if (dayDiff === 0) {
    dailyPrice = day_price_cents
  }

  if ((dayDiff === 1 && multi_day_pricing_list?.includes(1))) {
    //if 1 day only or same day pickup dropoff
    dailyPrice = day_price_N_cents?.one_day ?
      day_price_N_cents?.one_day : day_price_cents
  } else if (dayDiff === 1) {
    dailyPrice = day_price_cents
  }

  if ((dayDiff === 2 && multi_day_pricing_list?.includes(2))) {
    // 0 discount percentage is daydiff == 2
    dailyPrice = day_price_N_cents?.two_days ?
      day_price_N_cents?.two_days : day_price_cents
  } else if (dayDiff === 2) {
    dailyPrice = day_price_cents
  }

  if ((dayDiff === 3 && multi_day_pricing_list?.includes(3))) {
    // 5% discount percentage if daydiff == 3
    dailyPrice = day_price_N_cents?.three_days ?
      day_price_N_cents?.three_days : day_price_5_cents
  } else if (dayDiff === 3) {
    dailyPrice = day_price_cents
  }

  if (dayDiff >= 4 && multi_day_pricing_list?.includes(4)) {
    // 10% discount percentage if daydiff == 4
    dailyPrice = day_price_N_cents?.more_than_4_days ?
      day_price_N_cents?.more_than_4_days : day_price_10_cents
  } else if (dayDiff >= 4) {
    dailyPrice = day_price_cents
  }
  return dailyPrice
}

export const canShowStrickeOutForMultiday = (multi_day_pricing_list, startDate, endDate) => {
  let startDateMoment = moment(startDate, 'YYYY-MM-DD')
  let endDateMoment = moment(endDate, 'YYYY-MM-DD')
  let dayDiff = endDateMoment.diff(startDateMoment, 'days')

  if ((
    multi_day_pricing_list.includes(4) ||
    multi_day_pricing_list.includes(3) || 
    (multi_day_pricing_list.includes(2) && dayDiff == 2))
    && dayDiff >= 3
  ) {
    return true
  } else if (
    (!multi_day_pricing_list.includes(4) && dayDiff >= 4) ||
    (!multi_day_pricing_list.includes(3) && dayDiff >= 3) ||
    (!multi_day_pricing_list.includes(2) && dayDiff >= 2)
  ) {
    return false
  } else {
    return false
  }
}

const twentyPercentDiscount = (dailyPriceCents) => {
  return dailyPriceCents - (0.20 * dailyPriceCents)
}

export const findPriceForLoggedInUser = (
    cardInfo, startDate, endDate, multi_day_pricing_list, isTripTaken
  ) => {
    if (!isTripTaken && (!startDate || !endDate)) {
      // if rider has not ridden and no trip length mentioned always show 20% discounted price
      return twentyPercentDiscount(cardInfo.day_price_cents)
    } else if (!isTripTaken && startDate && endDate) {
      // in this case user has not ridden with us, based on trip length show the per day price
      return findPriceForNonLoggedInUser(cardInfo.day_price_cents, startDate, endDate)
    } else if (isTripTaken) {
      // if rider has already ridden with us, then no change in the UI, just show  price based on trip length and bike multiday discount
      return findMultidayPrice(cardInfo, startDate, endDate, multi_day_pricing_list)
    }
}

export const findPriceForNonLoggedInUser = (
  dailyPriceCents, startDate, endDate
) => {
  let startDateMoment = moment(startDate, 'YYYY-MM-DD')
  let endDateMoment = moment(endDate, 'YYYY-MM-DD')
  let dayDiff = endDateMoment.diff(startDateMoment, 'days')

  if (isNaN(dayDiff) || dayDiff < 4) {
    // when not logged in and trip length is < 4, display price per day by substacting 20% discount in dailyPriceCents
    return twentyPercentDiscount(dailyPriceCents)
  } else if (dayDiff >= 4) {
    // when not logged in and trip length is >= 4, display price per day based on 1 free day discount
    return (dailyPriceCents  - (dailyPriceCents / dayDiff))
  } else {
    // return 1 free day discount as fallback
    return (dailyPriceCents  - (dailyPriceCents / dayDiff))
  } 
}

const titleCase = (str) => {
  var splitStr = str.toLowerCase().split(' ')
  if (splitStr[0]) {
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] =
        splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
    }
    return splitStr.join(' ')
  } else {
    return str
  }
}

export const buildSearchTitle = (total, location, includeCount) => {
  let searchTitle = includeCount ? Number(total) + ' ' : ''
  if (location == "Nowhere") {
    if (total === 1) {
    searchTitle += 'motorcycle'
    }
    if (total > 1 || total === 0) {
      searchTitle += 'motorcycles'
    }
    return searchTitle += " for rent near your search location"
  }
  let city = undefined
  let state = undefined
  //This is a hot fix for locations search
  if (location[0]?.includes('Best Motorcycle')) {
    city = location[0].split('The Best Motorcycle Rentals in ')[1]
    state = location[1].split(' |')[0].trim() + ', USA'
  } else {
    if (location && location.indexOf(',') !== -1) {
      city = titleCase(location.substring(0, location.indexOf(',')))
      state = location.split(',')[1]
    }
  }
  if (total === 1) {
    searchTitle += 'motorcycle'
  }
  if (total > 1 || total === 0) {
    searchTitle += 'motorcycles'
  }
  if (location) {
    searchTitle += ' for rent near '
    searchTitle += city ? city + ', ' + state?.toUpperCase() : location
  } else {
    searchTitle += ' found.'
  }
  return searchTitle
}

export const buildSearchMetaTagTitle = (location) => {
  let searchTitle = 'The Best Motorcycle Rentals in '
  let city = undefined
  let state = undefined
  //This is a hot fix for locations search
  if (location[0]?.includes('Best Motorcycle')) {
    city = location[0].split('The Best Motorcycle Rentals in ')[1]
    state = location[1].split(' |')[0].trim() + ', USA'
  } else {
    if (location && location.indexOf(',') !== -1) {
      city = titleCase(location.substring(0, location.indexOf(',')))
      state = location.split(',')[1]
    }
  }
  if (location) {
    searchTitle += city ? city + ', ' + state?.toUpperCase() : location
  }
  searchTitle += ' | Twisted Road'
  return searchTitle
}

export const navBarOffSet = (isMobile) => {
  let mainNavBarEl = document.getElementById('main-header-wrap')
  let searchFilterBarEl = document.getElementById('search-filters-bar')

  if (!mainNavBarEl) {
    return {
      layoutStart: 0,
      filterStart: 0,
    }
  }

  let layoutStart = 0

  if (isMobile) {
    //make sure we have mobile
    layoutStart = mainNavBarEl.offsetHeight
  }

  if (!isMobile && searchFilterBarEl) {
    //if not mobile, we make sure the filtersbar has mounted
    layoutStart = mainNavBarEl.offsetHeight + searchFilterBarEl.offsetHeight
  }

  return {
    layoutStart: layoutStart,
    filterStart: mainNavBarEl.offsetHeight,
  }
}

export const canShowCrossedDailyRentalPrice = (
  startDate,
  endDate,
  has_multiday,
  multi_day_pricing_list
) => {
  let startDateMoment = moment(startDate, 'YYYY-MM-DD')
  let endDateMoment = moment(endDate, 'YYYY-MM-DD')
  let dayDiff = endDateMoment.diff(startDateMoment, 'days')

  if ((isNaN(dayDiff) || multi_day_pricing_list?.includes(dayDiff)) && has_multiday) {
    return true
  } else if (dayDiff > 4 && has_multiday) {
    return true
  }
  return false
}
